var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconOrganization(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6364 5.80403C15.1455 5.80403 16.3545 4.56538 16.3545 3.03092C16.3545 1.49647 15.1455 0.257812 13.6364 0.257812C12.1273 0.257812 10.9091 1.49647 10.9091 3.03092C10.9091 4.56538 12.1273 5.80403 13.6364 5.80403ZM6.36364 5.80403C7.87273 5.80403 9.08182 4.56538 9.08182 3.03092C9.08182 1.49647 7.87273 0.257812 6.36364 0.257812C4.85455 0.257812 3.63636 1.49647 3.63636 3.03092C3.63636 4.56538 4.85455 5.80403 6.36364 5.80403ZM6.36364 7.65277C4.24545 7.65277 0 8.73428 0 10.8881V13.199H12.7273V10.8881C12.7273 8.73428 8.48182 7.65277 6.36364 7.65277ZM13.6364 7.65277C13.3727 7.65277 13.0727 7.67126 12.7545 7.69899C13.8091 8.47546 14.5455 9.52 14.5455 10.8881V13.199H20V10.8881C20 8.73428 15.7545 7.65277 13.6364 7.65277Z",
    fill: "#CCCFD1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOrganization);
export default __webpack_public_path__ + "static/media/icon-organization.cc0299d60a44c7337641dcbce246dc5e.svg";
export { ForwardRef as ReactComponent };